import { Tooltip } from '@mui/material';
import { sortData } from '../../../utils';
import { Col, Row } from 'react-bootstrap';
import { isActionDisabled } from '../action-utils';

const ActionSuppComp = (props) => {
  const { actionSettings, onClick, node } = props || {};

  const sortedActions = sortData(
    actionSettings?.filter((a) => !a?.hide),
    'orderNum'
  );

  return node?.group ? (
    <div></div>
  ) : (
    <div>
      <Row className="d-flex gap-3 action-column-padding">
        {sortedActions?.map((action) => {
          const { type, disableCriteria } = action || {};
          const actionStyle = isActionDisabled(node?.data, disableCriteria)
            ? 'preview-style'
            : '';
          return (
            <Col
              disabled
              key={type}
              role="button"
              md={1}
              className={actionStyle}
            >
              <Tooltip title={action?.label} placement="top" arrow={true}>
                <i
                  className={`fas ${action?.icon} action-column-button`}
                  onClick={() => onClick?.(type)}
                />
              </Tooltip>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ActionSuppComp;
